<template>
  <div id="app">
    <div id="nav">
      <img alt="Vue logo"  id='logo' src="./assets/ARTHUR_1.png">
    </div>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
  })
}
</script>
<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .text-left{
    text-align: left;
  }
  .d-flex{
    display: flex
  }
  .container1{
    margin:auto;
    max-width:500px;
  }
  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  #logo{
    max-width:400px;
    width:100%;
  }
</style>
